document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-klaviyo-form]');
  if (!trigger) return;
  if (typeof window._klOnsite === 'undefined') return;
  e.preventDefault();
  window._klOnsite.push(['openForm', trigger.dataset.klaviyoForm]);
});

(function () {
  const hero = document.querySelector('.yns-hero[data-hero-visual="roadmap"]');
  if (!hero || !('IntersectionObserver' in window)) return;

  const steps = hero.querySelectorAll('.yns-hero__step, .yns-hero__step-mobile');
  if (!steps.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  steps.forEach((step) => observer.observe(step));
})();
